import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { useSnackbar } from 'notistack';
import LoadingIndicator from '../LoadingIndicator'
import TokenService from '../../services/TokenService';

export default function AddCustomerNote(props) {
    const [note, setNote] = React.useState('');

    const [isLoading, setIsLoading] = React.useState(false);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [formValidation, setFormValidation] = React.useState({
        isValid: false,
        errors: []
    });

    function validate() {

        let isValid = true;
        let errors = [];

        if (note.trim() == '') {
            errors["Note"] = "Enter a Note.";
            isValid = false;
        }

        if (isValid) {
        
        }

        setFormValidation({
            isValid: isValid,
            errors: errors
        });

        return {
            isValid: isValid,
            errors: errors
        }
    }

    const handleClose = (didAccept) => {
        if (didAccept) {
            if (validate().isValid) {
                setIsLoading(true);

                let postData = {
                     clientId: props.clientId
                    ,noteType: props.noteType
                    ,note: note
                }

                TokenService.adminServicePost(postData, 'Admin_AddCustomerNote', '')
                    .then((response) => {
                        setIsLoading(false);
                        //response = response[Object.keys(response)[0]];
                        if (response.Result == "SUCCESS") {
                            let clientNote = JSON.parse(response.JsonData);
                            props.close(true, clientNote);
                        }

                    })
                    .catch((response) => {
                        enqueueSnackbar('Error in Add Customer Note', {
                            variant: 'error',
                        });
                        setIsLoading(false);
                    });
            }
        }
        else {
            props.close(false);
        }

        
        //setisShown(false);
    };



        return (<div>
            <Dialog
            fullWidth
                open={true}
                onClose={(e) => handleClose(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {props.Title}
                </DialogTitle>
                <DialogContent>
                    {isLoading ?
                        <LoadingIndicator />
                        :
                        <>
                            <div style={{ alignSelf: 'center', marginTop: '10px' }}>
                                {props.noteType == 'Customer' ?
                                    <>Add a Customer Facing Note</>
                                :
                                    <>Add an Internal Note</>
                                }
                            </div>
                            <div style={{ alignSelf: 'center', marginTop: '10px' }}>
                                <TextField style={{ width: '100%', alignSelf: 'flex-start' }} label="Note" onChange={(e) => setNote(e.target.value)} value={note} variant="outlined" />
                                <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['Note'] !== undefined ? formValidation.errors['Note'] : ''}</div>
                            </div>
                        </>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={(e) => handleClose(false)} autoFocus>
                        Cancel
                    </Button>
                    <Button onClick={(e) => handleClose(true)}>
                        Add
                    </Button>
                </DialogActions>
            </Dialog>
        </div>);




}